import { mergeDeepLeft } from 'ramda';

import {
  LOAD_ALL_TASKS,
  LOAD_DETAILS_WITHOUT_PROPERTY,
  LOAD_DETAILS_BY_BOARD_ID,
  LOAD_TASKS_WITHOUT_POSITION,
  LOAD_TASK_CLOCKS,
  REVERT_TASK_ASSIGNMENT_BY_TASK_ID,
  SET_TASK_POSITION_BY_TASK_ID_AND_POSITION,
  SEND_EMAIL_BY_TASK_ID_AND_STAGE_ID,
  ARCHIVED_BY_TASK_ID,
  LOAD_DETAIL_PROJECT_TASKS,
  CLEAR_LANES,
  CLEAR_TASKS,
} from '../../actions/dashboard';

import {
  ADD_NEW_PROJECT,
  ARCHIVE_TASK,
    DELETE_TASKS_BY_IDS,
} from '../../actions/tasks';

function _addNewWO(state, payload) {
  setTimeout(function () {
    window.location.reload();
  }, 1000);
}

function archiveTask(state, payload) {
  const stateClone = JSON.parse(JSON.stringify(state));
  for (let i = stateClone.tasks.length; i--;) {
    if (parseInt(stateClone.tasks[i].task_id) === parseInt(payload.archived)) {
      stateClone.tasks.splice(i, 1);
    }
  }
  return Object.assign({}, state, stateClone);
}

function addProjectTasks(state, payload) {
  const stateClone = JSON.parse(JSON.stringify(state));

  stateClone.projectTasks = payload;

  return mergeDeepLeft(stateClone, state);
}

function removeTasksByIds(state, payload) {
    const tasks =  state.projectTasks.filter(
            task => !payload.ids.includes(task.id)
    );

    const newState = {...state};
    newState.projectTasks = tasks;

    return newState;
}

export default function dashboard(state = {}, action) {
    switch (action.type) {
        case ADD_NEW_PROJECT:
          _addNewWO(state, action.payload);
          return Object.assign({}, state, action.payload);
        case LOAD_DETAIL_PROJECT_TASKS:
          const newState = addProjectTasks(state, action.payload);
          return newState;
        case LOAD_ALL_TASKS:
            return Object.assign({}, state, action.payload);
        case CLEAR_LANES:
          delete state.lanes;
          return Object.assign({}, state, action.payload);
        case LOAD_DETAILS_WITHOUT_PROPERTY:
            return Object.assign({}, state, action.payload);
        case LOAD_DETAILS_BY_BOARD_ID:
            return Object.assign({}, state, action.payload);
        case LOAD_TASKS_WITHOUT_POSITION:
            return Object.assign({}, state, action.payload);
        case LOAD_TASK_CLOCKS:
            return Object.assign({}, state, action.payload);
        case REVERT_TASK_ASSIGNMENT_BY_TASK_ID:
            return Object.assign({}, state, action.payload);
        case ARCHIVE_TASK:
            return archiveTask(state, action.payload);
        case SET_TASK_POSITION_BY_TASK_ID_AND_POSITION:
            let tasks = state.tasks;
            for (let i = 0; i < tasks.length; i++) {
              if (action.payload.task_id == tasks[i].task_id) {
                tasks[i].stage = action.payload.stage_id;
              }
            }
            return Object.assign({}, state, action.payload);
        case SEND_EMAIL_BY_TASK_ID_AND_STAGE_ID:
            return Object.assign({}, state, action.payload);
        case ARCHIVED_BY_TASK_ID:
            return Object.assign({}, state, action.payload);
        case DELETE_TASKS_BY_IDS:
            return removeTasksByIds(state, action.payload);
        case CLEAR_TASKS:
            return {};
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/dashboard/index.js